import React from 'react'

import { AddressLookup } from '@grandvisionhq/checkout-v2'
import { FormGroup, Street } from '@grandvisionhq/forms'

import {
  Address,
  City,
  CountryFixed,
  FirstName,
  LastName,
  PostalCode,
  Region,
  Salutation,
} from './controls'
import { FormProps } from './types'

type Props = {
  isRequiredRegion?: boolean
  streetComponent?: React.ElementType
  shouldCombineAddress?: boolean
} & FormProps

const AddressForm: React.FC<Props> = ({
  isRequiredRegion = true,
  streetComponent = Street,
  shouldCombineAddress,
}) => (
  <React.Fragment>
    <FormGroup columns={3}>
      <Salutation />
    </FormGroup>
    <FormGroup columns={2}>
      <FirstName />
      <LastName />
    </FormGroup>
    <Address streetComponent={streetComponent} shouldCombineAddress={shouldCombineAddress} />
    <FormGroup>
      <City />
    </FormGroup>
    <FormGroup>
      <Region required={isRequiredRegion} />
    </FormGroup>
    <FormGroup>
      <PostalCode />
    </FormGroup>
    <FormGroup>
      <CountryFixed />
    </FormGroup>
  </React.Fragment>
)

export const CheckoutAddressForm = (props) => (
  <AddressForm {...props} streetComponent={AddressLookup} />
)
export const CheckoutOverviewAddressForm = (props) => <AddressForm {...props} />

export default AddressForm
